
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppSimpleTable, AppTable, AppButton } from '@/components';
import { usePromotionPrototypeList } from '@/modules/promotion/prototype/model/list';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { componentColumn, TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.PROTOTYPE.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { itemsInPage, fetchItemsInPage, total, query, actions } = usePromotionPrototypeList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                componentColumn()({
                    label: 'Personas',
                    component: AppSimpleTable,
                    propsHandler: (row: any) => ({
                        items: row.personas,
                        fields: ['rfmPersonaName', 'packageId', 'price', 'credit', 'rate'],
                        isVisibleHeader: false
                    })
                }),
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PROMOTION.PROTOTYPE.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-copy',
                        theme: 'info',
                        tooltip: 'Clone',
                        to: { name: ROUTE_NAME_PROMOTION.PROTOTYPE.ADD, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchItemsInPage);

        return { table, itemsInPage, total, query, fetchItemsInPage, actions, ROUTE_NAME_PROMOTION };
    }
});
